define('models/vendor',["T1", "T1Model"], function (T1, T1Model) {
  "use strict";

  T1.Models.Vendor = T1Model.extend({
    canCache: true,
    url: "vendors"
  });
  return T1.Models.Vendor;
});
